<template>
  <div class="article-saving-flow">
    <bookmark-button
      @toggle="onBookmarkClick()"
      :isSaved="articleSaved"
    ></bookmark-button>

    <alert-box
      :isSaved="articleSaved"
      :class="{ '--is-active': displayAlert }"
    ></alert-box>

    <auth-modal
      :bedrock-api-host="bedrockApiHost"
      :bedrock-client-token="bedrockClientToken"
      :bedrock-client-secret="bedrockClientSecret"
      :authenticated-callback="completeArticleSaving"
      use-case="saveArticle"
    />
  </div>
</template>

<script>
import {
  getUserProfile,
  saveArticleAuthed,
  deleteSavedArticle
} from './apis/profile'
import { getAuthenticatedUser, isAuthenticated } from 'js/bankrate-utilities'
import { getCustomer } from './apis/user'

import BookmarkButton from './components/bookmark-button.vue'
import tagularModule from 'js/store/helpers/tagular'
import { AuthModal } from '@bankrate/cxp-components'

import alertBox from '../components/alert-box.vue'

import '@bankrate/vue-components/dist/br-components.css'

export default {
  name: 'article-saving',
  data: () => ({
    bedrockApiHost: process.env.BEDROCK_API_HOST,
    bedrockClientToken: process.env.BEDROCK_API_CLIENT_TOKEN,
    bedrockClientSecret: process.env.BEDROCK_API_CLIENT_SECRET,
    // Article Saving
    name: '',
    email: '',
    articleId: null,
    articleSaved: false,

    // Flow control
    show: false,

    displayAlert: false,
    isLoading: false,
    completed: false,

    // Tracking
    googleButtonClicked: false,
    bookmark: {
      hasBeenToggled: false
    },
    signUpForm: {
      viewed: false,
      uuid: tagularModule.generateUniqueId()
    },

    // Error Handling
    isSuccessful: false,
    hasError: false,
    messageType: ''
  }),
  mounted() {
    this.articleId = document
      .querySelector("meta[name='articleId']")
      .getAttribute('content')

    if (isAuthenticated()) {
      this.getSavedStatus()
      getCustomer(getAuthenticatedUser())
        .then(response => {
          this.email = response.data.email
        })
        .catch(error => {
          console.log(error)
        })
    }
  },

  methods: {
    toggleAlertBox() {
      setTimeout(() => {
        this.displayAlert = false
      }, 3000)
    },

    transitionToArticleSaved() {
      // tmp
      this.isLoading = false
      this.completed = true
      this.articleSaved = true
    },

    transitionToGeneralError() {
      this.isLoading = false
      this.isSuccessful = false
      this.hasError = true
      this.showForgotPassword = false
      this.showArticleSavedFlow = false
      this.messageType = ''
    },

    onBookmarkClick() {
      if (!this.bookmark.hasBeenToggled) {
        this.bookmark.hasBeenToggled = true
        this.trackInitialBookmarkToggle()
      }

      if (!isAuthenticated()) {
        window.openBaeModal()

        return
      }

      const bearerToken = getAuthenticatedUser()

      if (!this.articleSaved) {
        saveArticleAuthed(this.articleId, bearerToken)
          .then(() => {
            this.transitionToArticleSaved()
            this.displayAlert = true
            this.toggleAlertBox()
          })
          .catch(() => {
            this.transitionToGeneralError()
          })
      } else {
        deleteSavedArticle(this.articleId, bearerToken)
          .then(() => {
            this.articleSaved = false
            this.displayAlert = true
            this.toggleAlertBox()
          })
          .catch(() => {
            // We feel that presenting an error to the user here would be a more negative experience
            this.articleSaved = false
          })
      }
    },

    getSavedStatus() {
      getUserProfile(getAuthenticatedUser())
        .then(response => {
          if (
            response.data.article_ids &&
            response.data.article_ids.length > 0
          ) {
            this.articleSaved = response.data.article_ids.includes(
              this.articleId
            )
          }
        })
        .catch(() => {
          // We feel that presenting an error to the user here would be a more negative experience
          // so we assume that they have not saved the article
          this.articleSaved = false
        })
    },

    completeArticleSaving(completedEvent) {
      this.isLoading = true
      this.name = completedEvent.name
      this.email = completedEvent.email
      saveArticleAuthed(this.articleId, getAuthenticatedUser())
        .then(() => {
          this.transitionToArticleSaved()
        })
        .catch(() => {
          this.transitionToGeneralError()
        })
    },

    trackInitialBookmarkToggle() {
      const webElement = {
        location: 'Article Pages',
        position: 'next to article title',
        elementType: 'button',
        text: 'Save Article',
        htmlId: 'save-articles'
      }

      const actionOutcome = 'Opens lite account modal'
      const outboundUrl = ''
      const correlationId = this.signUpForm.uuid

      tagularModule.elementClicked(
        webElement,
        actionOutcome,
        outboundUrl,
        correlationId,
        'redventures.authenticated.v1alpha1.ElementClicked'
      )
    }
  },

  components: {
    BookmarkButton,
    alertBox,
    AuthModal
  }
}
</script>
